export default "/fcbcac1db17390110677298f9d30eeed9c121039/14ed8dc335eec8ccd043173219a4387f.svg";